import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';

// Builds a staging-sandbox URL by combining the sandbox host with the path,
// query, and hash of a source URL (typically the page's live/published URL).
// Falls back to the sandbox root if the source URL cannot be parsed.
export const buildSandboxUrl = (sandboxDomain, sourceUrl) => {
  try {
    const {
      pathname,
      search,
      hash
    } = new URL(sourceUrl);
    return `https://${sandboxDomain}${pathname + search + hash}`;
  } catch (_unused) {
    return `https://${sandboxDomain}/`;
  }
};
export const THEME_EDITOR_URL = `${getFullUrl('app')}/theme-editor/${PortalIdParser.get()}/edit/@hubspot/elevate?onboardingTourId=edit-theme-settings`;
export const GLOBAL_HOME_URL = `${getFullUrl('app')}/global-home/${PortalIdParser.get()}`;